import React from 'react';
import { useEffectOnce } from 'react-use';
import { useDispatch } from 'react-redux';
import * as actions from '../NetWorthReport/NetWorthReportActions';
import NetWorthChart from './NetWorthChartContainer';

interface Props {
  clientId: string;
  range: string;
}

export const OverviewNetworthChart = ({ clientId, range }: Props) => {
  const dispatch = useDispatch();

  useEffectOnce(() => {
    dispatch(actions.fetch_data(null, clientId));
  });

  return <NetWorthChart clientId={clientId} range={range} />;
};
